import Cookies from 'js-cookie';
import { loadLanguageAsync } from '../i18n/i18n';

/**
 * Checks if language cookies are synced with backend preference
 */
const checkLanguageCookieSync = () => {
    const edcLanguage = Cookies.get('EDC-LANGUAGE') || 'en';
    const datahubLang = Cookies.get('datahub-lang');
    const i18nextLang = Cookies.get('i18next');

    // Check if all cookies are synced with EDC-LANGUAGE
    if (edcLanguage !== datahubLang || edcLanguage !== i18nextLang) {
        // Sync cookies to match backend preference
        Cookies.set('datahub-lang', edcLanguage);
        Cookies.set('i18next', edcLanguage);

        // Load new language if it's different from current
        loadLanguageAsync(edcLanguage)
            .then(() => {
                console.log(`Language successfully changed to ${edcLanguage}`);
            })
            .catch((error) => {
                console.error(`Failed to load language ${edcLanguage}:`, error);
            });
    }
};

/**
 * Starts language cookie polling to detect backend changes
 * @returns cleanup function to stop polling
 */
export const startLanguagePolling = (): (() => void) => {
    // Check immediately on start

    // Start polling immediately
    checkLanguageCookieSync();

    // Set up polling every 2 seconds to detect backend changes
    const pollInterval = setInterval(checkLanguageCookieSync, 2000);

    // Stop polling after 1 minute (60,000 ms)
    const stopTimeout = setTimeout(() => {
        clearInterval(pollInterval);
    }, 60000);

    // Return cleanup function
    return () => {
        clearInterval(pollInterval);
        clearTimeout(stopTimeout);
    };
};
